import React, {
  useState,
  Suspense,
  useEffect,
  useContext,
  useMemo,
  useLayoutEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import DifContext from './DifContext';

function DifWarnings(props) {
  //const dispatch = useDispatch();
  const [hideError, setHideError] = useState(false);
  const [showallerrors, setShowAllErrors] = useState(false);
  const { setErrorList, errorWarningsList } = useContext(DifContext);

  const { data, selectedDocType, allSelectedDocs, allDocs } = props;
  const showErrorList = () => {
    setHideError(false);
  };

  const hideErrorList = () => {
    setHideError(true);
  };

  const maxErrorsShownToggle = () => {
    setShowAllErrors(!showallerrors);
  };
  const mapping = {
    lpcoImageTypeCode: 'Document Type',
    lpcoReferenceNumber: 'Document Reference Number',
    identifier: 'URN',
    lpcoImageEffectiveDate: 'LPCO Image Effective Date',
    lpcoImageExpiryDate: 'LPCO Image Expiry Date',
  };
  var map = Object.keys(mapping);
  var map1 = Object.values(mapping);

   useEffect(() => {
    setTimeout(()=>{
        let ers = [];
        allSelectedDocs.forEach((item) =>
          Object.keys(mapping).forEach((err) => {
            if (data[item] && !data[item][err]) {
              ers.push({
                err: err,
                docType: item,
                msg: `${mapping[err]} - is mandatory`,
              });
            }
          })
        );
        setErrorList(ers)
        

    },500)
  
  }, [JSON.stringify(allSelectedDocs),JSON.stringify(data)]);



  let childShipment = '';
  if (props.isChildShipment) {
    childShipment = 'childShipment';
  }

  const maxErrorsShown = showallerrors ? errorWarningsList.length : 3;
  return (
    <div
      className={
        `warningBoxAboveFormcontentarea1 ${childShipment}` +
        (false ? ' warn ' : ' nowarn ')
      }
    >
      {errorWarningsList.length > 0 ? (
        hideError === true ? (
          <div
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={showErrorList}
          >
            <div className={`errorLine`}></div>&nbsp;
            <Icon name='plus circle' style={{ display: 'inline' }} />
            Expand&nbsp;Errors
          </div>
        ) : (
          <div
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={hideErrorList}
          >
            <div className={`errorLine`}></div>&nbsp;
            <Icon name='minus circle' style={{ display: 'inline' }} />
            Collapse&nbsp;Errors
          </div>
        )
      ) : (
        ''
      )}

      {/* {
  
allSelectedDocs.map((doc)=>{
const formData = data[doc]
  Object.keys(mapping).map(key=>formData[key]?null:
    )

}) 
} */}

      {errorWarningsList.length > 0 && (
        <div
          className={`ui error message ${
            hideError === true ? ' hideError' : ''
          }`}
        >
          <div className='contentDifWarnings'>
            <ul className='list'>
              {errorWarningsList.map((bbbbwarning, ioiii) => {
                if (bbbbwarning.shown === false) return null;
                if (ioiii >= maxErrorsShown) return null;
                return (
                  <li className='contentDifWarnings' key={ioiii}>
                    <div>
                      {bbbbwarning.targetName_c ? (
                        <a
                          className='warningLink'
                          href={'#' + bbbbwarning.targetName_c}
                          onClick={() => {
                            let invoiceToggleLink = document.getElementById(
                              'plus-' + bbbbwarning.invoice
                            );
                            invoiceToggleLink && invoiceToggleLink.click();
                            setTimeout(() => {
                              let toggleLink = document.getElementById(
                                'plus-' + bbbbwarning.targetName_c
                              );
                              toggleLink && toggleLink.click();
                            }, 1000);
                          }}
                        >
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  <span>
                                    {bbbbwarning.location}
                                    :&nbsp;
                                  </span>
                                </td>
                                <td>{bbbbwarning.msg}</td>
                              </tr>
                            </tbody>
                          </table>
                        </a>
                      ) : (
                        <span className={`warnTypewarning}`}>
                          {bbbbwarning.msg}
                        </span>
                      )}
                      {!(maxErrorsShown > errorWarningsList.length) &&
                        ioiii + 1 == maxErrorsShown &&
                        (showallerrors ||
                          errorWarningsList.length - maxErrorsShown > 0) && (
                          <a href='#' onClick={() => maxErrorsShownToggle()}>
                            &nbsp; &nbsp; &nbsp;
                            {!showallerrors ? (
                              <span>
                                ...
                                {errorWarningsList.length - maxErrorsShown} more
                              </span>
                            ) : (
                              <span>&nbsp; &nbsp; &nbsp; ...less</span>
                            )}
                          </a>
                        )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default DifWarnings;
